<mat-card class="crud-search-card">
  <mat-card-title i18n="@@type.Ranger">Ranger</mat-card-title>
  <mat-card-content>
    <form [formGroup]="searchForm">
      <div class="search-section">
        <!--
        <mat-form-field matTooltip="Ranger Id" [matTooltipDisabled]="disabledTooltip(this.rangerId)">
          <mat-label i18n="@@type.Ranger.rangerId">Ranger Id</mat-label>
          <input matInput formControlName="rangerId" id="rangerIdFilterInput" (ngModelChange)="rangerIdChanging($event)"
            [(ngModel)]="rangerIdFilter" (ngModelChange)="rangerIdChanged($event)" #rangerIdFilterInput type="number"
            placeholder="Ranger Id">
        </mat-form-field>
        -->

        <mat-form-field matTooltip="Select a Business Unit from the list"
          [matTooltipDisabled]="disabledTooltip(this.businessUnit)">
          <mat-label i18n="@@type.Ranger.businessUnit">Business Unit</mat-label>
          <mat-select formControlName="businessUnit" id="businessUnitFilterInput"
            (ngModelChange)="businessUnitChanging($event)" [(ngModel)]="businessUnitFilter"
            (ngModelChange)="businessUnitChanged($event)" #businessUnitFilterInput placeholder="Business Unit"
            [compareWith]="businessUnitCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let businessUnit of businessUnitSelectionList" [value]="businessUnit">
              {{businessUnit?.buId}} - {{businessUnit?.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Select a Cost Centre from the list"
          [matTooltipDisabled]="disabledTooltip(this.costCentre)">
          <mat-label i18n="@@type.Ranger.costCentre">Cost Centre</mat-label>
          <mat-select formControlName="costCentre" id="costCentreFilterInput"
            (ngModelChange)="costCentreChanging($event)" [(ngModel)]="costCentreFilter"
            (ngModelChange)="costCentreChanged($event)" #costCentreFilterInput placeholder="Cost Centre"
            [compareWith]="costCentreCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let costCentre of costCentreSelectionList" [value]="costCentre">
              {{costCentre?.ccId}} - {{costCentre?.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Select a Police Contact from the list" [matTooltipDisabled]="disabledTooltip(this.policeContact)">
          <mat-label i18n="@@type.Ranger.policeContact">Police Contact</mat-label>
          <mat-select formControlName="policeContact" id="policeContactFilterInput"              
              (ngModelChange)="policeContactChanging($event)" [(ngModel)]="policeContactFilter"              
              (ngModelChange)="policeContactChanged($event)" #policeContactFilterInput              
              placeholder="Police Contact" [compareWith]="policeContactCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let policeContact of policeContactSelectionList" [value]="policeContact">
              {{policeContactDisplay(policeContact)}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Select a Status from the list" [matTooltipDisabled]="disabledTooltip(this.status)">
          <mat-label i18n="@@type.Ranger.status">Status</mat-label>
          <mat-select formControlName="status" id="statusFilterInput" (ngModelChange)="statusChanging($event)"
            [(ngModel)]="statusFilter" (ngModelChange)="statusChanged($event)" #statusFilterInput placeholder="Status">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let status of statusSelectionList" [value]="status.code">
              {{status.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>

      </div>
      <div class="search-section">
         <mat-form-field matTooltip="Select a Volunteer Ranger from the list" [matTooltipDisabled]="disabledTooltip(this.volunteerRanger)">
          <mat-label i18n="@@type.Ranger.volunteerRanger">Volunteer Ranger</mat-label>
          <mat-select formControlName="volunteerRanger" id="volunteerRangerFilterInput"              
              (ngModelChange)="volunteerRangerChanging($event)" [(ngModel)]="volunteerRangerFilter"              
              (ngModelChange)="volunteerRangerChanged($event)" #volunteerRangerFilterInput>
            <mat-option>Any</mat-option>
            <mat-option [value]="true" i18n="@@type.boolean.true">Yes</mat-option>
            <mat-option [value]="false" i18n="@@type.boolean.false">No</mat-option>
          </mat-select>
          
        </mat-form-field>

         <mat-form-field matTooltip="Select a Wildlife Manager Ranger from the list" [matTooltipDisabled]="disabledTooltip(this.wildlifeManagerRanger)">
          <mat-label i18n="@@type.Ranger.wildlifeManagerRanger">Wildlife Manager Ranger</mat-label>
          <mat-select formControlName="wildlifeManagerRanger" id="wildlifeManagerRangerFilterInput"              
              (ngModelChange)="wildlifeManagerRangerChanging($event)" [(ngModel)]="wildlifeManagerRangerFilter"              
              (ngModelChange)="wildlifeManagerRangerChanged($event)" #wildlifeManagerRangerFilterInput>
            <mat-option>Any</mat-option>
            <mat-option [value]="true" i18n="@@type.boolean.true">Yes</mat-option>
            <mat-option [value]="false" i18n="@@type.boolean.false">No</mat-option>
          </mat-select>
        </mat-form-field>

		<mat-form-field matTooltip="Select a Provisional Ranger from the list" [matTooltipDisabled]="disabledTooltip(this.provisionalRanger)">
          <mat-label i18n="@@type.Ranger.provisionalRanger">Provisional Ranger</mat-label>
          <mat-select formControlName="provisionalRanger" id="provisionalRangerFilterInput"              
              (ngModelChange)="provisionalRangerChanging($event)" [(ngModel)]="provisionalRangerFilter"              
              (ngModelChange)="provisionalRangerChanged($event)" #provisionalRangerFilterInput>
            <mat-option>Any</mat-option>
            <mat-option [value]="true" i18n="@@type.boolean.true">Yes</mat-option>
            <mat-option [value]="false" i18n="@@type.boolean.false">No</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Select a Firearms Authority Expired from the list" [matTooltipDisabled]="disabledTooltip(this.firearmsAuthorityExpired)">
          <mat-label i18n="@@type.Ranger.firearmsAuthorityExpired">Authority Expired</mat-label>
          <mat-select formControlName="firearmsAuthorityExpired" id="firearmsAuthorityExpiredFilterInput"              
              (ngModelChange)="firearmsAuthorityExpiredChanging($event)" [(ngModel)]="firearmsAuthorityExpiredFilter"              
              (ngModelChange)="firearmsAuthorityExpiredChanged($event)" #firearmsAuthorityExpiredFilterInput>
            <mat-option>Any</mat-option>
            <mat-option [value]="true" i18n="@@type.boolean.true">Yes</mat-option>
            <mat-option [value]="false" i18n="@@type.boolean.false">No</mat-option>
          </mat-select>
         </mat-form-field> 
         
        <mat-form-field matTooltip="Select a Firearms Authority Expiring Soon from the list" [matTooltipDisabled]="disabledTooltip(this.firearmsAuthorityExpiringSoon)">
          <mat-label i18n="@@type.Ranger.firearmsAuthorityExpiringSoon">Authority Expiring Soon</mat-label>
          <mat-select formControlName="firearmsAuthorityExpiringSoon" id="firearmsAuthorityExpiringSoonFilterInput"              
              (ngModelChange)="firearmsAuthorityExpiringSoonChanging($event)" [(ngModel)]="firearmsAuthorityExpiringSoonFilter"              
              (ngModelChange)="firearmsAuthorityExpiringSoonChanged($event)" #firearmsAuthorityExpiringSoonFilterInput>
            <mat-option>Any</mat-option>
            <mat-option [value]="true" i18n="@@type.boolean.true">Yes</mat-option>
            <mat-option [value]="false" i18n="@@type.boolean.false">No</mat-option>
          </mat-select>
         </mat-form-field> 
      </div>
      <div class="search-section">
        <mat-form-field matTooltip="Name" [matTooltipDisabled]="disabledTooltip(this.name)" >
          <mat-label i18n="@@type.Ranger.name">Name</mat-label>
          <input matInput formControlName="name" id="nameFilterInput" (ngModelChange)="nameChanging($event)"
            [(ngModel)]="nameFilter" (ngModelChange)="nameChanged($event)" #nameFilterInput maxlength="45"
            placeholder="Name">
        </mat-form-field>

        <mat-form-field matTooltip="Email" [matTooltipDisabled]="disabledTooltip(this.email)">
          <mat-label i18n="@@type.Ranger.email">Email</mat-label>
          <input matInput formControlName="email" id="emailFilterInput" (ngModelChange)="emailChanging($event)"
            [(ngModel)]="emailFilter" (ngModelChange)="emailChanged($event)" #emailFilterInput maxlength="50"
            placeholder="Email">
        </mat-form-field>

        <mat-form-field matTooltip="Postcode" [matTooltipDisabled]="disabledTooltip(this.postcode)">
          <mat-label i18n="@@type.Ranger.postcode">Postcode</mat-label>
          <input matInput formControlName="postcode" id="postcodeFilterInput" (ngModelChange)="postcodeChanging($event)"
            [(ngModel)]="postcodeFilter" (ngModelChange)="postcodeChanged($event)" #postcodeFilterInput maxlength="8"
            placeholder="Postcode">
        </mat-form-field>

        <mat-form-field matTooltip="Town" [matTooltipDisabled]="disabledTooltip(this.town)">
          <mat-label i18n="@@type.Ranger.town">Town</mat-label>
          <input matInput formControlName="town" id="townFilterInput" (ngModelChange)="townChanging($event)"
            [(ngModel)]="townFilter" (ngModelChange)="townChanged($event)" #townFilterInput maxlength="45"
            placeholder="Town">
        </mat-form-field>

      </div>

      <div class="search-section">

        <mat-form-field matTooltip="Addr1" [matTooltipDisabled]="disabledTooltip(this.addr1)">
          <mat-label i18n="@@type.Ranger.addr1">Addr1</mat-label>
          <input matInput formControlName="addr1" id="addr1FilterInput" (ngModelChange)="addr1Changing($event)"
            [(ngModel)]="addr1Filter" (ngModelChange)="addr1Changed($event)" #addr1FilterInput maxlength="45"
            placeholder="Addr1">
        </mat-form-field>

        <mat-form-field matTooltip="Addr2" [matTooltipDisabled]="disabledTooltip(this.addr2)">
          <mat-label i18n="@@type.Ranger.addr2">Addr2</mat-label>
          <input matInput formControlName="addr2" id="addr2FilterInput" (ngModelChange)="addr2Changing($event)"
            [(ngModel)]="addr2Filter" (ngModelChange)="addr2Changed($event)" #addr2FilterInput maxlength="45"
            placeholder="Addr2">
        </mat-form-field>

        <mat-form-field matTooltip="Addr3" [matTooltipDisabled]="disabledTooltip(this.addr3)">
          <mat-label i18n="@@type.Ranger.addr3">Addr3</mat-label>
          <input matInput formControlName="addr3" id="addr3FilterInput" (ngModelChange)="addr3Changing($event)"
            [(ngModel)]="addr3Filter" (ngModelChange)="addr3Changed($event)" #addr3FilterInput maxlength="45"
            placeholder="Addr3">
        </mat-form-field>

          <mat-form-field matTooltip="Mobile Phone" [matTooltipDisabled]="disabledTooltip(this.mobilePhone)">
              <mat-label i18n="@@type.Ranger.mobilePhone">Mobile Phone</mat-label>
              <input matInput formControlName="mobilePhone" id="mobilePhoneFilterInput"
                     (ngModelChange)="mobilePhoneChanging($event)" [(ngModel)]="mobilePhoneFilter"
                     (ngModelChange)="mobilePhoneChanged($event)" #mobilePhoneFilterInput
                     maxlength="255" placeholder="Mobile Phone">
          </mat-form-field>
      </div>

      <div class="search-section">

        <mat-slide-toggle floatLabel="always" appearance="none" color="primary" *ngIf="autoSearchControlsEnabled"
          [(ngModel)]="autoSearch" [ngModelOptions]="{standalone: true}">
          Auto Search
        </mat-slide-toggle>

        <button mat-raised-button color="primary" class="action-button" (click)="forceSearch()" type="button"
          i18n="@@actions.search">Search</button>


        <button mat-raised-button color="primary" class="action-button" (click)="clearFilters()" type="button"
          [disabled]="!allowsClearFilters()" i18n="@@actions.clearFilters">Clear Filters</button>
      </div>

    </form>

    <div class="mat-elevation-z8">
      <div class="mat-table-wrapper">
        <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc" matSortDisableClear cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" Group>

          <ng-container matColumnDef="status">
            <mat-header-cell [crud-column-header]="columns.column('status')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-verysmall"
              i18n="@@type.Ranger.status">
              Status
            </mat-header-cell>
            <mat-cell class="search-column-verysmall" *matCellDef="let element">
              {{element.status | refDecode:'RANGER_STATUS' | async}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="rangerId">
            <mat-header-cell [crud-column-header]="columns.column('rangerId')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.Ranger.rangerId">
              Ranger Id
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.rangerId | number:'1.0-2':'en-GB'}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="businessUnit.buId">
            <mat-header-cell [crud-column-header]="columns.column('businessUnit.buId')" *matHeaderCellDef
              mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-verysmall"
              i18n="@@type.Ranger.businessUnit">
              Business Unit
            </mat-header-cell>
            <mat-cell class="search-column-verysmall" *matCellDef="let element">
              {{element.businessUnit?.buId}} - {{element.businessUnit?.name}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="costCentre.ccId">
            <mat-header-cell [crud-column-header]="columns.column('costCentre.ccId')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.Ranger.costCentre">
              Cost Centre
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.costCentre?.ccId}} - {{element.costCentre?.name}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="rangerSource.rangerSourceMapId">
            <mat-header-cell [crud-column-header]="columns.column('rangerSource.rangerSourceMapId')" *matHeaderCellDef
              mat-sort-header cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.Ranger.rangerSource">
              Ranger Source
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.rangerSource?.rangerSourceMapId}} - {{element.rangerSource?.sourceName}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="provisionalRanger">
            <mat-header-cell [crud-column-header]="columns.column('provisionalRanger')" *matHeaderCellDef
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.Ranger.provisionalRanger">
              Provisional Ranger
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.provisionalRanger">check_box</mat-icon>
              <mat-icon *ngIf="!element.provisionalRanger">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="wildlifeManagerRanger">
            <mat-header-cell [crud-column-header]="columns.column('wildlifeManagerRanger')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.Ranger.wildlifeManagerRanger">
                Wildlife Manager Ranger 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.wildlifeManagerRanger">check_box</mat-icon><mat-icon *ngIf="!element.wildlifeManagerRanger">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="volunteerRanger">
            <mat-header-cell [crud-column-header]="columns.column('volunteerRanger')" *matHeaderCellDef
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.Ranger.volunteerRanger">
              Volunteer Ranger
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              <mat-icon *ngIf="element.volunteerRanger">check_box</mat-icon>
              <mat-icon *ngIf="!element.volunteerRanger">check_box_outline_blank</mat-icon>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="addr1">
            <mat-header-cell [crud-column-header]="columns.column('addr1')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.Ranger.addr1">
              Addr1
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.addr1}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="addr2">
            <mat-header-cell [crud-column-header]="columns.column('addr2')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.Ranger.addr2">
              Addr2
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.addr2}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="addr3">
            <mat-header-cell [crud-column-header]="columns.column('addr3')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.Ranger.addr3">
              Addr3
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.addr3}}
            </mat-cell>
          </ng-container>


          <ng-container matColumnDef="createdBy">
            <mat-header-cell [crud-column-header]="columns.column('createdBy')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.Ranger.createdBy">
              Created By
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.createdBy}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="createdDate">
            <mat-header-cell [crud-column-header]="columns.column('createdDate')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.Ranger.createdDate">
              Created Date
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.createdDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="updatedBy">
            <mat-header-cell [crud-column-header]="columns.column('updatedBy')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.Ranger.updatedBy">
              Updated By
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.updatedBy}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="updatedDate">
            <mat-header-cell [crud-column-header]="columns.column('updatedDate')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.Ranger.updatedDate">
              Updated Date
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.updatedDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="email">
            <mat-header-cell [crud-column-header]="columns.column('email')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-medium"
              i18n="@@type.Ranger.email">
              Email
            </mat-header-cell>
            <mat-cell class="search-column-medium" *matCellDef="let element">
              {{element.email}}
            </mat-cell>
          </ng-container>

          

          <ng-container matColumnDef="firearmsAuthorityExpiryDate">
            <mat-header-cell [crud-column-header]="columns.column('firearmsAuthorityExpiryDate')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.Ranger.firearmsAuthorityExpiryDate">
                Firearms Authority Expiry Date 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.firearmsAuthorityExpiryDate | uimDateFormat}} {{isFirearmsExpired(element.firearmsAuthorityExpiryDate) ? '(expired)': ''}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="firearmsAuthorityIssueDate">
            <mat-header-cell [crud-column-header]="columns.column('firearmsAuthorityIssueDate')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.Ranger.firearmsAuthorityIssueDate">
                Firearms Authority Issue Date 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.firearmsAuthorityIssueDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="name">
            <mat-header-cell [crud-column-header]="columns.column('name')" *matHeaderCellDef mat-sort-header cdkDropList
              cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-medium"
              i18n="@@type.Ranger.name">
              Name
            </mat-header-cell>
            <mat-cell class="search-column-medium" *matCellDef="let element">
              {{element.name}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="postcode">
            <mat-header-cell [crud-column-header]="columns.column('postcode')" *matHeaderCellDef mat-sort-header
              cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-verysmall"
              i18n="@@type.Ranger.postcode">
              Postcode
            </mat-header-cell>
            <mat-cell class="search-column-verysmall" *matCellDef="let element">
              {{element.postcode}}
            </mat-cell>
          </ng-container>

            <ng-container matColumnDef="mobilePhone">
                <mat-header-cell [crud-column-header]="columns.column('mobilePhone')" *matHeaderCellDef
                                 mat-sort-header cdkDropList cdkDropListLockAxis="x"
                                 cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
                                 class="search-column-small" i18n="@@type.Ranger.mobilePhone">
                    Mobile Phone
                </mat-header-cell>
                <mat-cell class="search-column-small" *matCellDef="let element">
                    {{element.mobilePhone}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="town">
            <mat-header-cell [crud-column-header]="columns.column('town')" *matHeaderCellDef mat-sort-header cdkDropList
              cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
              (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag class="search-column-small"
              i18n="@@type.Ranger.town">
              Town
            </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.town}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions" stickyEnd>
            <mat-header-cell class="search-column-actions mat-elevation-z9" *matHeaderCellDef>
              <span i18n="@@common.actions">Actions</span>
              <app-column-picker-dialog-launcher [columns]="columns">
              </app-column-picker-dialog-launcher>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="search-column-actions mat-elevation-z9">
              <button class="action-button" *ngIf="allowsEdit(element)" mat-raised-button color="primary"
                [routerLink]="editRoute(element)" [queryParams]="editRouteQueryParams()" i18n="@@actions.edit"
                id="actions.edit">Edit</button>
              <button class="action-button" [queryParams]="viewRouteQueryParams()" *ngIf="allowsView(element)"
                mat-raised-button color="primary" [routerLink]="viewRoute(element)" i18n="@@actions.view"
                id="actions.view">View</button>
              <button class="action-button" *ngIf="allowsDelete(element)" mat-raised-button color="accent"
                (click)="deleteWithConfirmation(element)" i18n="@@actions.delete" id="actions.delete">Delete</button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="columns.displayedColumns" class="search-table"></mat-header-row>
          <mat-row *matRowDef="let row; columns: columns.displayedColumns;" class="search-table"></mat-row>

        </mat-table>
      </div>
      <mat-paginator [length]="pageInfo.totalElements" [pageSize]="pageInfo.size" [pageSizeOptions]="pageSizes">
      </mat-paginator>

      <button class="action-button" *ngIf="allowsCreate()" mat-raised-button color="primary"
        [routerLink]="createRoute()" [queryParams]="createRouteQueryParams()" i18n="@@actions.create"
        id="actions.create">Create</button>
      <button class="action-button" *ngIf="allowsBack()" mat-raised-button color="accent" [routerLink]="backRoute()"
        [queryParams]="backRouteQueryParams()" i18n="@@actions.back" id="actions.back">Back</button>
      <button class="action-button" mat-raised-button color="accent" (click)="exportFirearmsByPoliceAuthorityReport()" i18n="@@actions.Ranger.firearmsByPoliceAuthorityReport" id="actions.Ranger.firearmsByPoliceAuthorityReport">Export Firearms By Police Authority</button>
    </div>
  </mat-card-content>
</mat-card>